import { supabase } from './supabase'

export type MarketingEventName =
  | 'landing_view'
  | 'app_store_click'
  | 'web_sign_in_click'
  | 'language_switch'
  | 'signup_completed'
  | 'client_created'
  | 'invitation_created'
  | 'cleaning_created'
  | 'checkout_started'
  | 'subscription_started'

export type MarketingLocale = 'en' | 'es' | 'pt-BR' | 'ja'

const attributionKey = 'tidyping-marketing-attribution'
const sessionKey = 'tidyping-marketing-session'

export interface MarketingAttribution {
  utm_source: string | null
  utm_medium: string | null
  utm_campaign: string | null
  utm_content: string | null
}

function clean(value: string | null) {
  return value?.trim().slice(0, 120) || null
}

export function marketingAttributionFromURL(url: URL): MarketingAttribution {
  return {
    utm_source: clean(url.searchParams.get('utm_source')),
    utm_medium: clean(url.searchParams.get('utm_medium')),
    utm_campaign: clean(url.searchParams.get('utm_campaign')),
    utm_content: clean(url.searchParams.get('utm_content')),
  }
}

function sessionID() {
  const current = window.sessionStorage.getItem(sessionKey)
  if (current) return current
  const next = crypto.randomUUID()
  window.sessionStorage.setItem(sessionKey, next)
  return next
}

function attribution() {
  const current = marketingAttributionFromURL(new URL(window.location.href))
  if (Object.values(current).some(Boolean)) {
    window.sessionStorage.setItem(attributionKey, JSON.stringify(current))
    return current
  }
  try {
    return JSON.parse(window.sessionStorage.getItem(attributionKey) ?? '') as MarketingAttribution
  } catch {
    return current
  }
}

export async function trackMarketingEvent(eventName: MarketingEventName, locale: MarketingLocale, metadata: Record<string, string> = {}) {
  if (window.navigator.doNotTrack === '1') return
  let referrerHost: string | null = null
  try { referrerHost = document.referrer ? new URL(document.referrer).hostname.slice(0, 180) : null } catch { /* invalid referrer */ }
  const values = attribution()
  await supabase.from('marketing_events').insert({
    session_id: sessionID(),
    event_name: eventName,
    locale,
    path: window.location.pathname.slice(0, 180),
    referrer_host: referrerHost,
    ...values,
    metadata,
  })
}
